module.exports = __webpack_public_path__ + "img/lg_ring_r_skip_0_0.fd3ae4da.png";